import { Button } from 'antd';
import {
  FileOutlined,
  DownloadOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { UploadFile } from 'antd';
import dayjs from 'dayjs';
import { StyledCustomDocument } from './style';
import { formatFileSize, getFileExtension } from '../../../utils/fileUtils';
import { Label } from 'ui/Label';

interface ExtendedUploadFile extends UploadFile {
  file_path?: string;
  isExisting?: boolean;
  file_size?: number;
  file_format?: string;
  created_at?: string;
}

interface CustomDocumentProps {
  file: ExtendedUploadFile;
  onDownload?: (file: ExtendedUploadFile) => void;
  onDelete?: (file: ExtendedUploadFile) => void;
  showActions?: boolean;
}

export const CustomDocument = ({
  file,
  onDownload,
  onDelete,
  showActions = true,
}: CustomDocumentProps) => {
  const intl = useIntl();

  const fileSize = file.file_size || file.size || 0;
  const fileFormat = getFileExtension(file.file_format, file.name);
  const uploadedAt = file.created_at;
  const hasMetadata = fileSize > 0 || fileFormat || uploadedAt;

  return (
    <StyledCustomDocument>
      <div className="custom-document-item">
        <div className="file-info">
          <FileOutlined />
          <div className="file-details">
            <Label className="file-name" label={file.name} title={true}></Label>
            {hasMetadata && (
              <div className="file-meta">
                {fileSize > 0 && (
                  <span className="file-detail">
                    <span>
                      {intl.formatMessage({
                        id: 'file_uploader.file_size',
                      })}
                    </span>
                    <strong>{formatFileSize(fileSize)}</strong>
                  </span>
                )}
                {fileFormat && (
                  <span className="file-detail">
                    <span>
                      {intl.formatMessage({
                        id: 'file_uploader.file_format',
                      })}
                    </span>
                    <strong>{fileFormat}</strong>
                  </span>
                )}
                {uploadedAt && (
                  <span className="file-detail">
                    <span>
                      {intl.formatMessage({
                        id: 'file_uploader.file_added',
                      })}
                    </span>
                    <strong>{dayjs(uploadedAt).format('DD.MM.YYYY')}</strong>
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
        {showActions && (
          <div className="file-actions">
            {onDownload && (
              <Button
                size="small"
                icon={<DownloadOutlined />}
                onClick={() => onDownload(file)}
                title={intl.formatMessage({ id: 'file_uploader.download' })}
              />
            )}
            {onDelete && (
              <Button
                size="small"
                icon={<DeleteOutlined />}
                onClick={() => onDelete(file)}
                title={intl.formatMessage({ id: 'file_uploader.delete' })}
              />
            )}
          </div>
        )}
      </div>
    </StyledCustomDocument>
  );
};
